// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_2Je","cls2":"AppsMegaMenu-cls2_Nfj AppsMegaMenu-cls1_2Je"};